'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var icons = require('@tempi/icons');
var getPropsIcon = require('./getPropsIcon.js');

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const getIconCompoment = (icon) => {
  if (!(icon == null ? void 0 : icon.name))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, __spreadValues({}, __spreadValues({
    name: icon == null ? void 0 : icon.name
  }, getPropsIcon.getPropsIcon({
    color: icon == null ? void 0 : icon.color,
    size: icon == null ? void 0 : icon.size
  }))));
};

exports.getIconCompoment = getIconCompoment;
